import Vue from 'vue';

import '@babel/polyfill';
import 'whatwg-fetch';

import "@/components/course/index.js";

import meta from "vue-meta";
Vue.use(meta);

import plugins from './plugins';
Vue.prototype.$pub = plugins;

import ElementUI from 'element-ui';
import '@/assets/css/element.scss';
Vue.use(ElementUI);

import Currency from '@/components/Currency.vue';
Vue.component('Currency', Currency);
import CurrencyNew from '@/components/CurrencyNew.vue';
Vue.component('CurrencyNew', CurrencyNew);
import TabsSimple from '@/components/TabsSimple'
Vue.component('TabsSimple', TabsSimple);

// quill editor
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// 公式所需
import katex from 'katex'
window.katex = katex;
import 'katex/dist/katex.min.css';
Vue.use(VueQuillEditor);

import Tabs from "@/components/Tabs";
Vue.component("Tabs", Tabs);

Vue.component("BlockTabs", () => import("@/components/BlockTabs.vue"));

import List from '@/components/List.vue';
Vue.component("list", List);

Vue.component("el-password", () => import("@/components/Password.vue"));

Vue.component("progress-bar", () => import("@/components/ProgressBar.vue"));

Vue.component("Message", () => import("@/components/Message.vue"));

// 事件总线
Vue.prototype.$eventBus = new Vue();

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份   
        "d+": this.getDate(), //日   
        "h+": this.getHours(), //小时   
        "m+": this.getMinutes(), //分   
        "s+": this.getSeconds(), //秒   
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度   
        "S": this.getMilliseconds() //毫秒   
    };
    if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

Date.prototype.formatLong = function () {
    return this.format("yyyy/MM/dd hh:mm:ss");
}

Vue.$loading = {
    show() {
        Vue.$loading.instance = ElementUI.Loading.service({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'transparent',
        });
    },
    close() {
        if (Vue.$loading.instance && Vue.$loading.instance.close) {
            Vue.$loading.instance.close();
        }
    }
};

Vue.prototype.$messagePromise = function (msg, config) {
    return new Promise(resolve => {
        config = Object.assign({
            message: msg,
            type: 'info',
            duration: 1000,
            showClose: false,
            onClose: function () {
                resolve();
            },
        },
            config
        );
        this.$message(config);
    });
};

Vue.prototype.$success = function (msg, config = {}) {
    config.type = 'success';
    return this.$messagePromise(msg, config);
};

Vue.prototype.$warning = function (msg, config = {}) {
    config.type = 'warning';
    return this.$messagePromise(msg, config);
};

Vue.prototype.$error = function (msg, config = {}) {
    config.type = 'error';
    return this.$messagePromise(msg, config);
};

Vue.prototype.$info = function (msg, config = {}) {
    config.type = 'info';
    return this.$messagePromise(msg, config);
};

Vue.prototype.$promiseConfirm = function (msg, config = {}) {
    return new Promise(resolve => {
        config = Object.assign({
            type: 'info',
            dangerouslyUseHTMLString: true
        },
            config
        );
        this.$confirm(msg, config.title || '提示', {
            ...config,
            callback: function (action) {
                if (action == 'confirm') {
                    resolve();
                } else if (config.callback) {
                    config.callback(action);
                }
            },
        });
    });
};

Vue.prototype.$storage = function () {
    let that = this;
    return {
        set: (key, data) => {
            let rawData = localStorage.getItem(key);
            if (rawData) {
                rawData = JSON.parse(rawData);
            } else {
                rawData = {};
            }
            rawData[that.$store.state.user_info.id] = data;
            localStorage[key] = JSON.stringify(rawData);
        },
        get: key => {
            let rawData = localStorage.getItem(key);
            if (rawData) {
                let data = JSON.parse(rawData)[
                    that.$store.state.user_info.id
                ];
                return data;
            }
        },
    };
};

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}